import { defineMessages } from 'react-intl'

export default defineMessages({
  editSchedulingPoll: {
    id: 'containers.SchedulingPollEditPage.editSchedulingPoll',
    defaultMessage: 'Edit Scheduling Poll',
  },
  saveChanges: {
    id: 'containers.SchedulingPollEditPage.saveChanges',
    defaultMessage: 'Save Changes',
  },
  pollUpdatedSuccess: {
    id: 'containers.SchedulingPollEditPage.pollUpdatedSuccess',
    defaultMessage: 'Scheduling poll updated successfully!',
  },
  updatePollError: {
    id: 'containers.SchedulingPollEditPage.updatePollError',
    defaultMessage: 'Failed to update scheduling poll',
  },
  loadPollError: {
    id: 'containers.SchedulingPollEditPage.loadPollError',
    defaultMessage: 'Failed to load scheduling poll',
  },
})
